import React  from 'react'
import moment from 'moment'
import BigCalendar from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import styled from 'styled-components'
import 'moment/locale/cs'
import 'moment/locale/de'
import 'moment/locale/pl'
import 'moment/locale/ru'
import { __ } from '../../services/translate'

const localizer = BigCalendar.momentLocalizer(moment)

const showDescription = (descr) => {
  if (descr) {
    alert(descr)
  }
}

export default ({ holidays, lang }) => (
  <BigCalendar
    localizer={localizer}
    views={['month']}
    events={holidays}
    culture={lang}
    messages={{
      previous: '<',
      next: '>',
      today: __('Dnes'),
    }}
    components={{
      event: ({ event }) => {
        return (
          <div onClick={() => showDescription(event.description)}>
            {event.title}<br/>
            {event.description && <Info>{event.description}</Info>}
          </div>
        )
      }
    }}
  />
)

const Info = styled.span`
  font-size: .7rem;
`
